
import mixins from "vue-typed-mixins";
import CustomValidation from "../mixins/CustomValidation";
import Common from "../mixins/Common";
import Sidebar from "primevue/sidebar";
import Password from "primevue/password";
import LottieAnimation from "@/components/LottieAnimationsComponent.vue";
import { mapMutations, mapGetters } from "vuex";
import { MarketplaceEstimatesViewModel } from "../interfaces/MarketplaceEstimatesViewModel";
import { PatientRegisterViewModel } from "@/interfaces/PatientRegisterViewModel";
import { object, string, boolean, number, date } from "yup";
import swal from "sweetalert";
import { AjaxReturnViewModel } from "@/interfaces/AjaxReturnViewModel";
import { PatientViewModel } from "@/interfaces/PatientViewModel";
import store from "@/store/index";
import { VueTelInput } from "vue-tel-input";
import moment from "moment";
import router from "@/router";
import { PatientPortalMedicationMarketplaceRx } from "@/interfaces/PatientPortalMedicationMarketplaceRx";
import Chips from "primevue/chips";
import { PatientAllergy } from "@/interfaces/PatientAllergy";
import { PatientMedication } from "@/interfaces/PatientMedication";
import { rxReceivedScreenView, rxEstimateScreenView } from "@/interfaces/PharmacyCartViewEnum";
import SubscriptionPaymentFlow from "../components/SubscriptionPaymentFlowComponent.vue";
import { subscriptionPaymentFlowScreenView } from "@/interfaces/SubscriptionPaymentFlowEnum";
import { AffiliateSubscription } from "@/interfaces/AffiliateSubscription";
import SubscriptionSelector from "@/components/MedicationMarketplaceSubscriptionSelectComponent.vue";
import { MarketplaceRxPaymentViewModel } from "@/interfaces/MarketplaceRxPaymentViewModel";

export interface ICollectJS {
  startPaymentRequest: (arg0: any) => void;
  configure: (arg0: any) => void;
}

export default mixins(CustomValidation, Common).extend({
  props: {
    type: {
      type: String,
      default: "",
    },
    view: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rxEstimateScreenView,
      rxReceivedScreenView,
      isLoadingCart: false as boolean,
      isLoadingSMS: false as boolean,
      transitionName: "slide-left" as string,
      medicationChoices: [] as MarketplaceEstimatesViewModel[],
      confirmPassword: "" as string,
      match: false,
      firstName: "" as string,
      lastName: "" as string,
      email: "" as string,
      password: "" as string,
      isPasswordShow: false as boolean,
      eightChars: false,
      oneNumber: false,
      lowerCase: false,
      upperCase: false,
      isConfirmPasswordVisible: false as boolean,
      enableSubmit: false,
      iAgree: false,
      signUpSchema: object().shape({
        password: string().typeError("Password is required.").required("Password is required."),
        confirmPassword: string().typeError("Password is required.").required("Password is required."),
        firstName: string().typeError("First Name is required.").required("First Name is required."),
        lastName: string().typeError("Last Name is required.").required("Last Name is required."),
        email: string().typeError("Email is required.").email("The Email field is not a valid e-mail address.").required("Email is required"),
        iAgree: boolean().typeError("You must agree to the terms of use privacy policy and consent to remote health.").oneOf([true], "You must agree to the terms of use privacy policy and consent to remote health.").required("You must agree to the terms of use privacy policy and consent to remote health."),
      }),
      gender: null as string | null,
      dobMonth: null as string | null,
      dobDay: null as string | null,
      dobYear: null as string | null,
      phone: "" as string,
      basicInfoSchema: object().shape({
        gender: string().typeError("Gender is required.").required(),
        dobMonth: number().integer().typeError("Invalid Month.").min(0, "Invalid Month.").max(12, "Invalid Month.").required(),
        dobDay: number().integer().typeError("Invalid Day.").min(0, "Invalid Day.").max(31, "Invalid Day.").required(),
        dobYear: number().integer().typeError("Invalid Year.").min(1900, "Invalid Year.").max(3000, "Invalid Year.").required(),
        dateOfBirthValidation: date().typeError("Invalid Birthdate.").required(),
        selectedState: string().typeError("State is required.").required("State is required."),
        phone: string()
          .typeError("Phone Number is required.")
          .matches(/^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/, "Invalid Phone Number.")
          .required("Phone Number is required."),
      }),
      currentSMSStep: 1 as number,
      digits: ["", "", "", "", "", ""] as string[],
      invalidCode: false as boolean,
      newCodeSent: false as boolean,
      defaultErrorMessage: false as boolean,
      formattedPhone: "" as string,
      phoneIsValid: false as boolean,
      patientData: {} as PatientViewModel,
      marketplaceRxs: [] as PatientPortalMedicationMarketplaceRx[],
      shippingDetailsSchema: object().shape({
        streetAddress: string().typeError("Address is required.").required("Address is required."),
        city: string().typeError("City is required.").required("City is required."),
        selectedState: string().typeError("State is required.").required("State is required."),
        zip: number().integer().typeError("Zip must be a number and is required.").max(99999, "Zip must be a number and is required.").required("Zip must be a number and is required."),
      }),
      streetAddress: "" as string | null,
      streetAddress2: "" as string | null,
      city: "" as string | null,
      zip: "" as string | null,
      selectedState: "" as string | null,
      states: [
        { name: "Alabama", abbr: "AL" },
        { name: "Alaska", abbr: "AK" },
        { name: "Arizona", abbr: "AZ" },
        { name: "Arkansas", abbr: "AR" },
        { name: "California", abbr: "CA" },
        { name: "Colorado", abbr: "CO" },
        { name: "Connecticut", abbr: "CT" },
        { name: "Delaware", abbr: "DE" },
        { name: "Florida", abbr: "FL" },
        { name: "Georgia", abbr: "GA" },
        { name: "Hawaii", abbr: "HI" },
        { name: "Idaho", abbr: "ID" },
        { name: "Illinois", abbr: "IL" },
        { name: "Indiana", abbr: "IN" },
        { name: "Iowa", abbr: "IA" },
        { name: "Kansas", abbr: "KS" },
        { name: "Kentucky", abbr: "KY" },
        { name: "Louisiana", abbr: "LA" },
        { name: "Maine", abbr: "ME" },
        { name: "Maryland", abbr: "MD" },
        { name: "Massachusetts", abbr: "MA" },
        { name: "Michigan", abbr: "MI" },
        { name: "Minnesota", abbr: "MN" },
        { name: "Mississippi", abbr: "MS" },
        { name: "Missouri", abbr: "MO" },
        { name: "Montana", abbr: "MT" },
        { name: "Nebraska", abbr: "NE" },
        { name: "Nevada", abbr: "NV" },
        { name: "New Hampshire", abbr: "NH" },
        { name: "New Jersey", abbr: "NJ" },
        { name: "New Mexico", abbr: "NM" },
        { name: "New York", abbr: "NY" },
        { name: "North Carolina", abbr: "NC" },
        { name: "North Dakota", abbr: "ND" },
        { name: "Ohio", abbr: "OH" },
        { name: "Oklahoma", abbr: "OK" },
        { name: "Oregon", abbr: "OR" },
        { name: "Pennsylvania", abbr: "PA" },
        { name: "Rhode Island", abbr: "RI" },
        { name: "South Carolina", abbr: "SC" },
        { name: "South Dakota", abbr: "SD" },
        { name: "Tennessee", abbr: "TN" },
        { name: "Texas", abbr: "TX" },
        { name: "Utah", abbr: "UT" },
        { name: "Vermont", abbr: "VT" },
        { name: "Virginia", abbr: "VA" },
        { name: "Washington", abbr: "WA" },
        { name: "West Virginia", abbr: "WV" },
        { name: "Wisconsin", abbr: "WI" },
        { name: "Wyoming", abbr: "WY" },
        { name: "District of Columbia", abbr: "DC" },
      ],
      authToken: null as string | null,
      keepVaultID: null as boolean | null,
      secCodeError: null as string | null,
      expDateError: null as string | null,
      cardNumError: null as string | null,
      ccInfoInvalid: false,
      userAllowsChargeAndFillUponApproval: false as boolean,
      shippingFee: 0 as number,
      childProofLid: false,
      patientAllergies: [] as PatientAllergy[],
      patientMedications: [] as PatientMedication[],
      allergyLabels: [] as string[],
      newAllergy: "" as string,
      medicationLabels: [] as string[],
      allergyNASelected: null as boolean | null,
      medicationNASelected: null as boolean | null,
      paymentAddressSchema: object().shape({
        homeStreetAddress: string().typeError("Address is required.").required("Address is required."),
        homeCity: string().typeError("City is required.").required("City is required."),
        selectedHomeState: string().typeError("State is required.").required("State is required."),
        homeZip: number().integer().typeError("Zip must be a number and is required.").max(99999, "Zip must be a number and is required.").required("Zip must be a number and is required."),
      }),
      homeStreetAddress: "" as string | null,
      homeStreetAddress2: "" as string | null,
      homeCity: "" as string | null,
      homeZip: "" as string | null,
      selectedHomeState: "" as string | null,
      orderID: "" as string | null,
      shippingIsSame: false as boolean,
      prefersChildProofLid: null as boolean | null,
      patientHasSubscription: false as boolean,
      affiliateSubscriptions: [] as AffiliateSubscription[],
      selectedSubscription: {} as AffiliateSubscription,
      isMonthly: true,
    };
  },
  computed: {
    ...mapGetters({
      ShowPharmacyCart: "getShowPharmacyCart",
      MarketplaceEstimates: "getMarketplaceEstimates",
      SignedIn: "getSignedIn",
      Content: "getContent",
      Affiliate: "getAffiliate",
      MarketplaceRxs: "getMarketplaceRxs",
      Theme: "getTheme",
      IsCollectJSLoaded: "getIsCollectJSLoaded",
      PharmacyCartView: "getPharmacyCartView",
      ForcePharmacyCartFlow: "getForcePharmacyCartFlow",
    }),
    dateOfBirthValidation(): Date | null {
      if (this.dobMonth !== null && this.dobDay !== null && this.dobYear !== null) {
        return moment(this.dateOfBirth, "YYYY-MM-DD").toDate();
      }
      return null;
    },
    dateOfBirth(): string | null {
      if (this.dobMonth !== null && this.dobDay !== null && this.dobYear !== null) {
        return this.dobYear + "-" + this.dobMonth + "-" + this.dobDay;
      }
      return null;
    },

    subTotalPrice(): number {
      const rxTotal = this.marketplaceRxs.reduce((sum, rx) => sum + rx.programPrice, 0);
      let subscriptionPrice = 0;
      if (this.selectedSubscription && Object.keys(this.selectedSubscription).length > 0) {
        const price = this.isMonthly ? this.selectedSubscription.monthlyPrice : this.selectedSubscription.yearlyPrice;
        subscriptionPrice = Number(price) || 0;
      }
      return rxTotal + subscriptionPrice;
    },
    totalPrice(): number {
      return this.subTotalPrice + this.shippingFee;
    },
    ifAllergiesExist(): boolean {
      return this.allergyLabels.length > 0 || this.allergyNASelected;
    },
    ifMedicationsExist(): boolean {
      return this.medicationLabels.length > 0 || this.medicationNASelected;
    },
    paddedOrderID(): string {
      return this.orderID.padStart(8, "0");
    },
    mainMemberRxs(): boolean {
      return this.marketplaceRxs.some((rx) => rx.userID === this.patientData.userID);
    },
  },
  watch: {
    password: function () {
      this.validatePassword();
    },
    confirmPassword: function () {
      this.validatePassword();
    },
    view(newVal) {
      if (this.type === "rxEstimate" && newVal === rxEstimateScreenView.signup) {
        this.setupValidation(this.signUpSchema);
      }
      if (this.type === "rxEstimate" && newVal === rxEstimateScreenView.chooseSubscription) {
        this.setShowSubscriptionPaymentFlow({ show: true, view: subscriptionPaymentFlowScreenView.selectProgram, forceFlow: false });
      }
      if (this.type === "rxEstimate" && newVal === rxEstimateScreenView.basicinfo) {
        this.setupValidation(this.basicInfoSchema);
        // Get fresh patient data when being emitted from subscription flow checkout back to basic info
        this.getServerPatientData();
      }
      if (this.type === "rxReceived" && newVal === rxReceivedScreenView.shipping) {
        this.setupValidation(this.shippingDetailsSchema);
      }
      if (this.type === "rxReceived" && newVal === rxReceivedScreenView.payment) {
        this.setupValidation(this.paymentAddressSchema);

        this.setupCollect();
        window.setInterval(() => {
          this.ccInfoInvalidChecker();
        }, 1000);
      }
    },
  },
  created() {
    // Initialize data from the Vuex store
    if (this.type === "rxEstimate") {
      this.medicationChoices = this.MarketplaceEstimates;
      if (this.type === "rxEstimate" && this.view === rxEstimateScreenView.basicinfo) {
        this.setupValidation(this.basicInfoSchema);
        // Get fresh patient data when being emitted from subscription flow checkout back to basic info
        this.getServerPatientData();
      }
      if (this.type === "rxEstimate" && this.view === rxEstimateScreenView.signup) {
        this.setupValidation(this.signUpSchema);
      }
    } else if (this.type === "rxReceived") {
      this.getMedicationMarketplaceCheckout();
    }
  },
  mounted() {
    window.onmessage = (e) => {
      if (!e.data || !e.data.messageType) return;
      switch (e.data.messageType) {
        case "UpdatePhoneNumber":
          this.closeSMSModal;
          break;
        case "ToggleSMS":
          this.toggleSMS(e.data.toggleSMSValue);
          break;
        default:
          break;
      }
    };
  },
  methods: {
    ...mapMutations({
      setShowPharmacyCart: "setShowPharmacyCart",
      setMarketplaceEstimates: "setMarketplaceEstimates",
      setLoading: "setLoading",
      setMarketplaceRxs: "setMarketplaceRxs",
      setShowSubscriptionPaymentFlow: "setShowSubscriptionPaymentFlow",
    }),
    toggleAllergyNA(value: any) {
      this.allergyNASelected = value;
    },
    toggleMedicationNA(value: any) {
      this.medicationNASelected = value;
    },
    preferChildProofLids(value: any) {
      this.prefersChildProofLid = value;
    },
    convertToTitleCase(string: any) {
      return string
        .toLowerCase()
        .split(" ")
        .map(function (word: any) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    },
    nextStep() {
      this.transitionName = "slide-left";
      this.isLoadingCart = true;

      setTimeout(() => {
        if (this.type === "rxReceived") {
          if (this.view === rxReceivedScreenView.shipping) {
            if (!this.patientHasSubscription) {
              // Force user to pick a subscription
              this.setShowPharmacyCart({ show: true, type: "rxReceived", view: rxReceivedScreenView.subscriptionOffer });
            } else {
              // Skip to payment
              this.setShowPharmacyCart({ show: true, type: "rxReceived", view: rxReceivedScreenView.payment });
            }
          } else if (this.view === rxReceivedScreenView.subscriptionOffer) {
            // After subscription offer, go to payment
            this.setShowPharmacyCart({ show: true, type: "rxReceived", view: rxReceivedScreenView.payment });
          } else {
            // Default: increment view
            this.setShowPharmacyCart({ show: true, type: "rxReceived", view: this.PharmacyCartView + 1 });
          }
        } else if (this.type === "rxEstimate") {
          this.setShowPharmacyCart({ show: true, type: "rxEstimate", view: this.PharmacyCartView + 1 });
        }

        this.isLoadingCart = false;
      }, 3000);
    },

    // Medication Cart Oveview (RxReceived)

    async getMedicationMarketplaceCheckout() {
      this.isLoadingCart = true;
      try {
        const rxArray = this.MarketplaceRxs.map((r) => r.rxID);

        const response = await this.$store.dispatch("GetMedicationMarketplaceCheckout", rxArray);
        if (!response || !response.success) {
          swal("Error", "Error loading cart. Please try again.");
          this.isLoadingCart = false;
          return;
        }
        if (response && response.data) {
          this.patientHasSubscription = response.data.patientHasSubscription;
          this.affiliateSubscriptions = response.data.affiliateSubscriptions;
          this.marketplaceRxs = response.data.marketplaceRxs;
          this.shippingFee = response.data.shippingFee;

          this.patientData = response.data.patient;

          this.streetAddress = this.patientData.streetAddress1;
          this.streetAddress2 = this.patientData.streetAddress2;
          this.city = this.patientData.city;
          this.selectedState = this.patientData.state;
          this.zip = this.patientData.zipCode;
          this.homeStreetAddress = this.patientData.homeStreetAddress1;
          this.homeStreetAddress2 = this.patientData.homeStreetAddress2;
          this.homeCity = this.patientData.homeCity;
          this.selectedHomeState = this.patientData.homeState;
          this.homeZip = this.patientData.homeZipCode;
          this.shippingIsSame = this.patientData.shippingIsSame;
          this.prefersChildProofLid = this.patientData.prefersChildProofLid;

          if (response.data.patientHasVault) {
            this.userAllowsChargeAndFillUponApproval = true;
            this.keepVaultID = true;
          }
          this.patientAllergies = response.data.patientAllergies;
          this.patientMedications = response.data.patientMedications;

          // Check for "N/A" before processing allergies and medications
          const hasNAAllergy = this.patientAllergies.some((a) => a.allergyDesc.trim().toLowerCase() === "n/a");
          const hasNAMedication = this.patientMedications.some((m) => m.medicationDesc.trim().toLowerCase() === "n/a");

          if (hasNAAllergy) {
            this.allergyNASelected = true;
            this.setAllergyNA();
          } else {
            this.allergyLabels = this.patientAllergies.filter((a) => a.active).map((a) => a.allergyDesc);
          }

          if (hasNAMedication) {
            this.medicationNASelected = true;
            this.setMedicationNA();
          } else {
            this.medicationLabels = this.patientMedications.filter((m) => m.active).map((m) => m.medicationDesc);
          }
        }
        this.isLoadingCart = false;
      } catch (error) {
        this.isLoadingCart = false;
        swal("Error", "Error loading cart. Please try again.");
      }
    },

    getLocalPatientData() {
      this.patientData.streetAddress1 = this.streetAddress;
      this.patientData.streetAddress2 = this.streetAddress2;
      this.patientData.city = this.city;
      this.patientData.state = this.selectedState;
      this.patientData.zipCode = this.zip;
      this.patientData.homeStreetAddress1 = this.homeStreetAddress;
      this.patientData.homeStreetAddress2 = this.homeStreetAddress2;
      this.patientData.homeCity = this.homeCity;
      this.patientData.homeState = this.selectedHomeState;
      this.patientData.homeZipCode = this.homeZip;
      this.patientData.shippingIsSame = this.shippingIsSame;
      this.patientData.prefersChildProofLid = this.prefersChildProofLid;
    },

    // If a family plan manager is only checking out with associate Rx's, they should not be presented with the allergy/medication screen
    checkRxOwnership() {
      if (this.mainMemberRxs) {
        this.nextStep();
      } else this.setShowPharmacyCart({ show: true, type: "rxReceived", view: rxReceivedScreenView.shipping });
    },

    // Allergy/Medication/Child-proof Lid Screen (RxReceived)

    addAllergy(event) {
      if (this.allergyNASelected) return;

      const newDesc = Array.isArray(event.value) ? event.value[event.value.length - 1] : event.value;
      // Check if the allergy already exists (case-insensitive comparison)
      const existingAllergy = this.patientAllergies.find((m) => m.allergyDesc.toLowerCase() === newDesc.toLowerCase());

      if (existingAllergy) {
        // If the allergy exists, mark it as active
        existingAllergy.active = true;

        // Remove duplicate from allergyLabels if it was added by Chips
        this.allergyLabels = this.allergyLabels.filter((label) => label.toLowerCase() !== newDesc.toLowerCase());
      } else {
        // If it does not exist, add it as a new entry
        this.patientAllergies.push({
          iD: 0, // New entry
          userID: 0,
          allergyDesc: newDesc,
          active: true,
          createdDate: new Date().toISOString(),
          modifiedDate: new Date().toISOString(),
        });
      }
      // Ensure the label is added only if it doesn't already exist
      if (!this.allergyLabels.includes(newDesc)) {
        this.allergyLabels.push(newDesc);
      }
      this.newAllergy = "";
    },
    removeAllergy(event: any) {
      // Ensure we extract the correct string from the array
      const removedDesc = Array.isArray(event.value) ? event.value[0] : event.value;

      // Remove from patientAllergies (completely delete the object)
      this.patientAllergies = this.patientAllergies.filter((a) => a.allergyDesc.toLowerCase() !== removedDesc.toLowerCase());
    },
    setAllergyNA() {
      if (this.allergyNASelected) {
        // Clear all existing allergies
        this.patientAllergies = [];
        this.allergyLabels = [];

        // Add "N/A" allergy
        this.patientAllergies.push({
          iD: 0,
          userID: 0,
          allergyDesc: "N/A",
          active: true,
          createdDate: new Date().toISOString(),
          modifiedDate: new Date().toISOString(),
        });
      } else {
        this.patientAllergies = [];
        this.allergyLabels = [];
      }
    },
    addPatMedication(event) {
      if (this.medicationNASelected) return;

      const newDesc = Array.isArray(event.value) ? event.value[event.value.length - 1] : event.value;

      // Check if the medication already exists (case-insensitive comparison)
      const existingMedication = this.patientMedications.find((m) => m.medicationDesc.toLowerCase() === newDesc.toLowerCase());

      if (existingMedication) {
        // If the medication exists, mark it as active
        existingMedication.active = true;

        // Remove duplicate from medicationLabels if it was added by Chips
        this.medicationLabels = this.medicationLabels.filter((label) => label.toLowerCase() !== newDesc.toLowerCase());
      } else {
        // If it does not exist, add it as a new entry
        this.patientMedications.push({
          iD: 0, // New entry
          userID: 0,
          medicationDesc: newDesc,
          active: true,
          createdDate: new Date().toISOString(),
          modifiedDate: new Date().toISOString(),
        });
      }
      // Ensure the label is added only if it doesn't already exist
      if (!this.medicationLabels.includes(newDesc)) {
        this.medicationLabels.push(newDesc);
      }
    },
    removePatMedication(event) {
      // Ensure we extract the correct string from the array
      const removedDesc = Array.isArray(event.value) ? event.value[0] : event.value;

      // Remove from patientMedications (completely delete the object)
      this.patientMedications = this.patientMedications.filter((a) => a.medicationDesc.toLowerCase() !== removedDesc.toLowerCase());
    },
    setMedicationNA() {
      if (this.medicationNASelected) {
        // Clear all existing medications
        this.patientMedications = [];
        this.medicationLabels = [];

        // Add "N/A" medication
        this.patientMedications.push({
          iD: 0,
          userID: 0,
          medicationDesc: "N/A",
          active: true,
          createdDate: new Date().toISOString(),
          modifiedDate: new Date().toISOString(),
        });
      } else {
        this.patientMedications = [];
        this.medicationLabels = [];
      }
    },
    async saveAllergiesMedications() {
      this.isLoadingCart = true;

      try {
        const payload = {
          allergies: this.patientAllergies,
          medications: this.patientMedications,
        };

        let resp = await this.$store.dispatch("UpdatePatientAllergiesMedications", payload);
        if (!resp || !resp.success) {
          swal("Error", "Error updating allergies/medications. Please try again.", "error");
          this.isLoadingCart = false;
          return;
        }

        this.getLocalPatientData();
        let resp1 = await this.$store.dispatch("SaveMarketplacePatient", this.patientData);
        if (!resp1) {
          swal("Error", "Error updating patient. Please try again.", "error");
          this.isLoadingCart = false;
          return;
        }

        this.nextStep();
      } catch (error) {
        this.isLoadingCart = false;
        console.error("Error:", error);
      }
    },

    // Shipping Details Screen (RxReceived)

    async saveShipping() {
      this.isLoadingCart = true;
      this.errors = [];
      this.schema
        .validate(this, { abortEarly: false })
        .then(async () => {
          this.errors = [];
          this.getLocalPatientData();
          let resp = await this.$store.dispatch("SaveMarketplacePatient", this.patientData);
          if (!resp) {
            swal("Error", "Error updating patient. Please try again.", "error");
            this.isLoadingCart = false;
            return;
          }
          this.nextStep();
        })
        .catch((err: { inner: any[] }) => {
          this.isLoadingCart = false;
          err.inner.forEach((error: { path: string; message: string }): void => {
            this.errors.push({ key: error.path, value: error.message });
          });
        });
    },
    backToCart() {
      this.transitionName = "slide-right";
      this.setShowPharmacyCart({ show: true, type: "rxReceived", view: rxReceivedScreenView.cart });
    },
    backToAddress() {
      this.transitionName = "slide-right";
      this.setShowPharmacyCart({ show: true, type: "rxReceived", view: rxReceivedScreenView.shipping });
    },
    backToSubscription() {
      this.transitionName = "slide-right";
      this.setShowPharmacyCart({ show: true, type: "rxReceived", view: rxReceivedScreenView.subscriptionOffer });
    },
    closeCart() {
      this.setShowPharmacyCart({ show: false, type: "" });
    },
    removeMarketplaceRx(index: any) {
      this.marketplaceRxs.splice(index, 1);
      this.setMarketplaceRxs(this.marketplaceRxs);

      // If this was the last rx removed the cart needs to close
      if (this.marketplaceRxs.length === 0) {
        this.setShowPharmacyCart({ show: false, type: "" });
      }
    },
    hideSidebar() {
      if (!this.ForcePharmacyCartFlow) {
        this.setShowPharmacyCart({ show: false, type: "", view: 0, force: false });
      }
    },

    // Checkout Screen (RxReceived)

    async setupCollect() {
      if ((this.authToken != null && this.authToken.length > 0) || this.keepVaultID) {
        this.setLoading(false);
        return false;
      }
      while (!(window as any).CollectJS) {
        await this.sleep(100);
      }

      while (!document.getElementById("cardNum") || !document.getElementById("expDate") || !document.getElementById("secCode")) {
        await this.sleep(100);
      }

      const CollectJS: ICollectJS = (window as any).CollectJS;
      CollectJS.configure({
        paymentSelector: "#customPayButton",
        styleSniffer: "true",
        customCss: {
          display: "block",
          width: "100%",
          height: "45px",
          padding: "0.375rem 0.75rem",
          "font-Size": "14px",
          "font-weight": "400",
          "line-height": "1.5",
          color: (this.Theme.Colors as { Key: string; Value: string }[]).find((x) => x.Key == "--m-text-color")?.Value,
          "background-color": (this.Theme.Colors as { Key: string; Value: string }[]).find((x) => x.Key == "--m-background")?.Value,
          "background-clip": "padding-box",
          border: "1px solid #ced4da",
          "border-radius": "0.25rem",
          transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        },
        fields: {
          ccnumber: {
            selector: "#cardNum",
            title: "Card Number",
            placeholder: "Credit Card Number",
          },
          ccexp: {
            selector: "#expDate",
            title: "Card Expiration",
            placeholder: "Exp. Date (MM/YY)",
          },
          cvv: {
            display: "show",
            selector: "#secCode",
            title: "CVV Code",
            placeholder: "CVV",
          },
        },
        variant: "inline",
        callback: async (response: { token: any }) => {
          console.log("CollectJS callback received response:", response);

          this.authToken = response.token;
          console.log(`this.authToken ${this.authToken}`);
          if (this.userAllowsChargeAndFillUponApproval) {
            this.keepVaultID = true;
          }
          this.setLoading(false);

          const payload: MarketplaceRxPaymentViewModel = {
            rxID: this.marketplaceRxs.map((rx) => rx.rxID),
            authToken: this.authToken,
            affiliateSubscription: this.selectedSubscription && Object.keys(this.selectedSubscription).length > 0 ? this.selectedSubscription : null, // send null if user isn't purchasing a subscription (they already have one)
            isMonthly: this.selectedSubscription && Object.keys(this.selectedSubscription).length > 0 ? this.isMonthly : null, // send null if user isn't purchasing a subscription, we won't need it
          };

          let response2 = await store.dispatch("SaveMarketplaceRxPayment", payload);

          if (!response2.success) {
            swal("Error", "Error during checkout. Please try again.", "error");
            this.isLoadingCart = false;
            return;
          }
          this.orderID = response2.data;
          this.nextStep();
        },
        validationCallback: (field: string, status: string, message: string) => {
          if (status) {
            switch (field) {
              case "ccnumber":
                this.cardNumError = null;
                break;
              case "ccexp":
                this.expDateError = null;
                break;
              case "cvv":
                this.secCodeError = null;
                break;
              default:
            }
          } else {
            switch (field) {
              case "ccnumber":
                this.cardNumError = message;
                break;
              case "ccexp":
                this.expDateError = message;
                break;
              case "cvv":
                this.secCodeError = message;
                break;
              default:
            }
            this.setLoading(false);
          }
        },
        timeoutDuration: 10000,
        timeoutCallback: () => {
          this.setLoading(false);
          swal("", "There was an error processing your credit card. Please try again. If you continue to experience this issue, please contact us.", "warning");
        },
        fieldsAvailableCallback: () => {
          this.setLoading(false);
        },
      });
      this.setLoading(false);
    },
    ccInfoInvalidChecker() {
      if (document.querySelectorAll(".CollectJSInlineIframe.CollectJSValid").length < 3) {
        this.ccInfoInvalid = true;
      } else {
        this.ccInfoInvalid = false;
      }
    },
    waitCCInfoValid(successCB: () => void, failureCB: () => void, retries: number) {
      window.setTimeout(() => {
        retries--;
        if (!this.ccInfoInvalid) {
          successCB();
        } else {
          if (retries > 0) {
            this.waitCCInfoValid(successCB, failureCB, retries);
          } else {
            failureCB();
          }
        }
      }, 500);
    },
    btnClearCreditCard_Click() {
      this.authToken = null;
      this.keepVaultID = false;
      this.setupCollect();
    },
    async savePaymentAddress() {
      this.errors = [];
      try {
        this.errors = [];
        if (this.shippingIsSame) {
          this.homeStreetAddress = this.streetAddress;
          this.homeStreetAddress2 = this.streetAddress2;
          this.homeCity = this.city;
          this.selectedHomeState = this.selectedState;
          this.homeZip = this.zip;
        }

        this.getLocalPatientData();

        await this.schema.validate(this, { abortEarly: false });

        let response = await this.$store.dispatch("SavePatient", { p: this.patientData });
        if (!response) {
          throw new Error("Error updating address. Please try again.");
        }
      } catch (err) {
        this.isLoadingCart = false;

        if (err.inner) {
          err.inner.forEach((error: { path: string; message: string }): void => {
            this.errors.push({ key: error.path, value: error.message });
          });
        }

        throw err;
      }
    },
    async checkout() {
      this.isLoadingCart = true;
      try {
        await this.savePaymentAddress();

        const CollectJS: ICollectJS = (window as any).CollectJS;

        if ((this.authToken != null && this.authToken.length > 0) || this.keepVaultID) {
          // already have cc info
          console.log("already have cc info");

          const payload: MarketplaceRxPaymentViewModel = {
            rxID: this.marketplaceRxs.map((rx) => rx.rxID),
            authToken: this.authToken,
            affiliateSubscription: this.selectedSubscription && Object.keys(this.selectedSubscription).length > 0 ? this.selectedSubscription : null, // send null if user isn't purchasing a subscription (they already have one)
            isMonthly: this.selectedSubscription && Object.keys(this.selectedSubscription).length > 0 ? this.isMonthly : null, // send null if user isn't purchasing a subscription, we won't need it
          };

          let response = await store.dispatch("SaveMarketplaceRxPayment", payload);

          console.log("SaveMarketplaceRxPayment response", response);
          if (!response.success) {
            this.isLoadingCart = false;
            swal("Error", "Error during checkout. Please try again.", "error");
            return;
          }
          console.log("checkout response", response);
          this.orderID = response.data;
          this.nextStep();
          return;
        }

        this.waitCCInfoValid(
          () => {
            // Success need to get cc info
            console.log("Success need to get cc info");
            console.log(event);
            CollectJS.startPaymentRequest(event);
          },
          () => {
            // Failure in cc info
            console.log("Failure in cc info");
            this.isLoadingCart = false;
            swal("", "Valid credit card information is required.", "warning");
          },
          6
        );
      } catch (error: any) {
        this.isLoadingCart = false;
        swal("Error", "Error during checkout. Please try again.", "error");
      }
    },
    handleShippingIsSameClick(e: Event) {
      this.validateShippingAddress(e);
    },
    validateShippingAddress(e: Event) {
      if (e != null && e.currentTarget != null && (e.currentTarget as HTMLInputElement).checked) {
        this.shippingIsSame = true;
      } else {
        this.shippingIsSame = false;
      }
    },
    finishCheckout() {
      this.setShowPharmacyCart({ show: false, type: "" });
      this.setLoading(true);
      window.location.reload();
    },

    // Sign Up Screen (RxEstimate)

    async signUp() {
      this.isLoadingCart = true;
      if (this.$gtm && this.$gtm.enabled() && this.Content.GTMConfig && !this.Content.GTMToggleOff) {
        window.dataLayer?.push({
          event: "signup",
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
        });
      }
      this.errors = [];
      this.schema
        .validate(this, { abortEarly: false })
        .then(async () => {
          this.errors = [];
          let prVM: PatientRegisterViewModel = { questionnaireTypeID: 0, iAgree: false, captchaToken: null, email: this.email, firstName: this.firstName, lastName: this.lastName, password: this.password, promoCode: null };
          let pVM = (await this.$store.dispatch("MedicationMarketplacePatientRegister", prVM)) as AjaxReturnViewModel<PatientViewModel>;
          if (!pVM || !pVM.success) {
            this.isLoadingCart = false;
            swal("Error", "Error creating user. If you already have an account a password reset email has been sent. If not, please try again.");
            return;
          }
          this.patientData = pVM.data;

          var signedIn = await this.$store.dispatch("SignIn", { u: prVM.email, p: prVM.password });
          if (!signedIn) {
            this.isLoadingCart = false;
            swal("Error", "Error signing in. If you already have an account a password reset email has been sent. If not, please try again.");
            return;
          }

          if (this.MarketplaceEstimates) {
            await this.$store.dispatch("UpdateMarketplaceEstimates", this.MarketplaceEstimates);
          }

          // Add logic here to check if user has any pending family plan requests.

          const pendingRequest = await this.$store.dispatch("GetPendingFamilyPlanRequest");

          if (pendingRequest && pendingRequest.data) {
            console.log("you have a pending family plan request");
            this.setShowSubscriptionPaymentFlow({ show: true, view: subscriptionPaymentFlowScreenView.familyPlanRequest, forceFlow: true });
            this.isLoadingCart = false;
            return;
          }

          this.nextStep();
        })
        .catch((err: { inner: any[] }) => {
          this.isLoadingCart = false;
          err.inner.forEach((error: { path: string; message: string }): void => {
            this.errors.push({ key: error.path, value: error.message });
          });
        });
    },
    validatePassword: function () {
      this.enableSubmit = false;

      if (this.password && this.password.length > 7) {
        this.eightChars = true;
      } else {
        this.eightChars = false;
      }
      var rgxON = RegExp("[0-9]");
      if (this.password && rgxON.test(this.password)) {
        this.oneNumber = true;
      } else {
        this.oneNumber = false;
      }
      var lcRGX = RegExp("[a-z]");
      if (this.password && lcRGX.test(this.password)) {
        this.lowerCase = true;
      } else {
        this.lowerCase = false;
      }
      var ucRGX = RegExp("[A-Z]");
      if (this.password && ucRGX.test(this.password)) {
        this.upperCase = true;
      } else {
        this.upperCase = false;
      }
      if (this.isConfirmPasswordVisible) {
        if (this.password && this.confirmPassword && this.password == this.confirmPassword) {
          this.match = true;
        } else {
          this.match = false;
        }
      } else if (!this.isConfirmPasswordVisible && this.password) {
        this.match = true;
        this.confirmPassword = this.password;
      } else {
        this.match = false;
      }
      if (this.eightChars && this.oneNumber && this.lowerCase && this.upperCase && this.match) {
        this.enableSubmit = true;
      }
    },
    togglePassword() {
      this.isPasswordShow = !this.isPasswordShow;
    },
    async removeMedication(index: any) {
      // Capture the medication being removed
      const removedMedication = { ...this.medicationChoices[index], active: false };

      // Remove the medication from the array
      this.medicationChoices.splice(index, 1);

      // Update estimates with the modified array
      this.setMarketplaceEstimates(this.medicationChoices);

      if (this.SignedIn) {
        // Send the removed medication with `active` set to false
        const payload = Array.isArray(removedMedication) ? removedMedication : [removedMedication];

        await this.$store.dispatch("UpdateMarketplaceEstimates", payload);
      }
    },

    // Basic Info Screen (RxEstimate)

    async basicInfo() {
      this.isLoadingCart = true;
      this.errors = [];
      this.schema
        .validate(this, { abortEarly: false })
        .then(async () => {
          if (this.$gtm && this.$gtm.enabled() && this.Content.GTMConfig && !this.Content.GTMToggleOff) {
            window.dataLayer?.push({
              event: "basicinfo",
              phone: this.phone,
            });
          }
          this.errors = [];

          if (this.patientData) {
            this.patientData.dateOfBirth = this.dateOfBirth;
            this.patientData.gender = this.gender;
            this.patientData.phone = this.phone;
            this.patientData.state = this.selectedState;
            if (this.patientData.homeState === null) {
              this.patientData.homeState = this.selectedState;
            }
          }

          await store.dispatch("SavePatient", { p: this.patientData });

          if (this.Affiliate.smsEnabled === true) {
            this.showSMSVerifyModal();

            await store.dispatch("GetSMSCode", { phone: this.phone });
            this.invalidCode = false;
            this.newCodeSent = false;
            this.defaultErrorMessage = false;

            return;
          }

          this.setShowPharmacyCart({ show: false, type: "", force: false });

          // If a user is updating their subscription, they are already on the `patientPortal` route
          // which will throw a navigation guard error. Easier to get the updated data this way instead
          // of manually updating everything. The else condition is for the original subscription sign up
          // flow if a user is signing up from `retailPharmacy`.

          if (this.$route.path === "/patientportal") {
            window.location.reload();
          } else {
            this.$router.push("/patientportal");
          }
        })
        .catch((err: { inner: any[] }) => {
          this.isLoadingCart = false;
          err.inner.forEach((error: { path: string; message: string }): void => {
            this.errors.push({ key: error.path, value: error.message });
          });
        });
    },
    dobDay_onKeyUp() {
      if (this.dobDay !== null && this.dobDay.length === 2) {
        (this.$refs.dobYear as HTMLElement).focus();
      }
    },
    dobMonth_onKeyUp() {
      if (this.dobMonth !== null && this.dobMonth.length === 2) {
        (this.$refs.dobDay as HTMLElement).focus();
      }
    },
    onInput(index: number, event: Event): void {
      const el = event.target as HTMLInputElement;
      const val = el.value.replace(/\D/g, ""); // keep digits only

      // if browser autofills all digits into the first input, split them
      if (val.length > 1) {
        const chars = val.slice(0, 6).split("");
        // populate digits (fill left-to-right)
        for (let i = 0; i < 6; i++) {
          this.$set(this.digits, i, chars[i] ?? "");
        }
        // optionally submit automatically when full
        if (this.digits.join("").length === 6) {
          this.submitCode();
        }
        return;
      }

      // keep single char for this box
      this.$set(this.digits, index, val);

      // move focus forward/backwards
      if (val && index < 5) {
        const next = (this.$refs.otpInputs as HTMLInputElement[])[index + 1];
        next?.focus();
      }
    },

    onPaste(event: ClipboardEvent): void {
      const pasted = (event.clipboardData || (window as any).clipboardData)?.getData("text") || "";
      const digitsOnly = pasted.replace(/\D/g, "").slice(0, 6);
      if (!digitsOnly) return;

      for (let i = 0; i < 6; i++) {
        this.$set(this.digits, i, digitsOnly[i] ?? "");
      }

      if (digitsOnly.length === 6) {
        this.submitCode();
      }
    },

    onKeyUp(index: number, event: KeyboardEvent): void {
      const key = event.key;
      const el = (this.$refs.otpInputs as HTMLInputElement[])[index];

      if (key === "Backspace" && !el.value && index > 0) {
        const prev = (this.$refs.otpInputs as HTMLInputElement[])[index - 1];
        prev?.focus();
      } else if (key === "Enter") {
        this.submitCode();
      }
    },

    async submitCode(): Promise<void> {
      const code = this.digits.join("");
      if (code.length !== 6) {
        this.invalidCode = true;
        return;
      }
      try {
        const response = await this.$store.dispatch("ValidateSMSCode", { code });

        if (response && response.success) {
          this.currentSMSStep = 2;
          setTimeout(() => {
            this.currentSMSStep = 3;
          }, 2000);
          this.setLoading(false);
        } else {
          this.invalidCode = true;
          this.newCodeSent = false;
          this.setLoading(false);
        }
      } catch (err) {
        console.error("OTP verify error", err);
        alert("Error verifying code, please try again later.");
      }
    },

    async toggleSMS(option: boolean) {
      this.setLoading(true);
      try {
        await this.$store.dispatch("ToggleSMS", { enabled: option });
        this.closeSMSModal();
        this.setShowPharmacyCart({ show: false, type: "" });

        const target = "/patientportal";
        if (this.$route.path !== target) {
          await this.$router.push(target);
        }
      } finally {
        this.setLoading(false);
      }
    },
    async resendCode() {
      try {
        this.setLoading(true);
        const response = await store.dispatch("GetSMSCode", { phone: this.phone });

        if (response && response.success === true) {
          this.invalidCode = false;
          this.newCodeSent = true;
          this.setLoading(false);
        } else {
          this.defaultErrorMessage = true;
          this.setLoading(false);
        }
      } catch (error) {
        console.error("Error sending SMS code: ", error);
        this.defaultErrorMessage = true;
      }
    },
    closeSMSModal() {
      this.isLoadingCart = false;
      const input = document.querySelector(".vti__input") as HTMLElement;

      this.$bvModal.hide("modal-sms");
      setTimeout(() => {
        if (input) {
          input.focus();
        }
      }, 1000);
    },
    showSMSVerifyModal() {
      this.formatPhoneNumber(this.phone);
      this.$bvModal.show("modal-sms");
    },
    formatPhoneNumber(phone: string) {
      const cleaned = phone.replace(/\D/g, "");

      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

      if (match) {
        this.formattedPhone = `(${match[1]}) ${match[2]}-${match[3]}`;
      } else {
        return phone;
      }
    },
    phone_validate(e: { isValid: any }) {
      this.phoneIsValid = e.isValid;
    },
    async getServerPatientData() {
      let resp = await this.$store.dispatch("GetPatientData");
      if (!resp) {
        swal("Error", "Error collecting patient data. Please try again.", "error");
        this.isLoadingCart = false;
        return;
      }
      this.patientData = resp;
      this.streetAddress = this.patientData.streetAddress1;
      this.streetAddress2 = this.patientData.streetAddress2;
      this.city = this.patientData.city;
      this.selectedState = this.patientData.state;
      this.zip = this.patientData.zipCode;
      this.homeStreetAddress = this.patientData.homeStreetAddress1;
      this.homeStreetAddress2 = this.patientData.homeStreetAddress2;
      this.homeCity = this.patientData.homeCity;
      this.selectedHomeState = this.patientData.homeState;
      this.homeZip = this.patientData.homeZipCode;
      this.shippingIsSame = this.patientData.shippingIsSame;
      this.prefersChildProofLid = this.patientData.prefersChildProofLid;
      this.phone = this.patientData.phone;
      this.gender = this.patientData.gender;
      this.setDOBproperties(this.patientData.dateOfBirth);
    },
    setDOBproperties(dob: string | null) {
      if (!dob) return;
      const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dob).trim());
      if (!match) return;
      const [, year, month, day] = match;
      this.dobYear = year; // "2000"
      this.dobMonth = month; // "05"
      this.dobDay = day; // "11"
    },
  },
  components: {
    Sidebar,
    LottieAnimation,
    Password,
    VueTelInput,
    Chips,
    SubscriptionPaymentFlow,
    SubscriptionSelector,
  },
});
